import React, { useState, useContext, useEffect, useRef } from 'react'
import Slider from 'react-slick'
import GridView from '@/custom/components/molecules/ProductCard/GridView'
import openSocket from 'socket.io-client'
import { messageHandler } from '@/product/common/socketHandler'
import ProductContext from '@/product/context/product/productContext'
import AlertContext from '@/product/context/alert/alertContext'
import AuthContext from '@/product/context/auth/authContext'

const ProductsSlider = (props) => {
    const [viewProduct, setViewProduct] = useState([])
    const productContext = useContext(ProductContext)
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated, saveSearch } = authContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    const { search_allproducts, getAllSearchProducts, responseStatus, addSavedSearch } =
        productContext

    const settings = {
        dots: false,
        arrows: true,
        infinite: viewProduct.length > 5, // Only enable infinite if there are enough items
        swipeToSlide: true,
        draggable: true,
        variableWidth: true,
        centerPadding: '190px',
        centerMode: viewProduct.length > 5, // Only enable centerMode if there are enough items
        initialSlide: 0,
        slidesToShow: Math.min(5.5, viewProduct.length), // Adjust slidesToShow based on item count
        slidesToScroll: 1,
        autoplay: true,
        speed: 500,
        rtl: false,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: Math.min(5.5, viewProduct.length),
                    slidesToScroll: 1,
                    centerMode: viewProduct.length > 5,
                    infinite: viewProduct.length > 5,
                    initialSlide: 0,
                },
            },
            {
                breakpoint: 1370,
                settings: {
                    slidesToShow: Math.min(5, viewProduct.length),
                    slidesToScroll: 1,
                    centerMode: viewProduct.length > 5,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: Math.min(4.5, viewProduct.length),
                    slidesToScroll: 1,
                    centerMode: viewProduct.length > 5,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: Math.min(3, viewProduct.length),
                    slidesToScroll: 1,
                    centerMode: viewProduct.length > 3,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: Math.min(3, viewProduct.length),
                    slidesToScroll: 1,
                    centerMode: viewProduct.length > 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: Math.min(2, viewProduct.length),
                    slidesToScroll: 1,
                    centerMode: viewProduct.length > 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: Math.min(2, viewProduct.length),
                    slidesToScroll: 1,
                    centerMode: viewProduct.length > 2,
                },
            },
            {
                breakpoint: 475,
                settings: {
                    slidesToShow: Math.min(1, viewProduct.length),
                    slidesToScroll: 1,
                    centerMode: viewProduct.length > 2,
                },
            },
        ],
    }

    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)

    // Sets product and user refrences on page load
    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
            null,
            global?.successBidMessage,
        )
    }
    // Used to display items in wishlist on page load
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'watchlist') {
                handler(
                    {
                        id: responseStatus.data.project_id,
                        status: responseStatus.data.status,
                    },
                    'watchlistAdded',
                )
            }
        }
    }, [responseStatus])

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, { transports: ['websocket'] })
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })
        socket.on('cancelBidEmitted', (data) => {
            // formikSearch.values.filters.auctionid.value = [Number(props.match.params.aid)]
            // getAllSearchProducts(formikSearch.values, 'searchproducts')
        })
        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('cancelBidEmitted', (data) => {})
            socket.disconnect()
        }
    }, [])

    useEffect(() => {
        if (props.products) {
            setViewProduct(props.products)
        }
    }, [props.products])

    return (
        <div className="pb-4 customContainer">
            <div className="home-content-head customContainer">{props.title}</div>
            <Slider {...settings}>
                {viewProduct.map((data, index) => (
                    <>
                        <GridView data={data} favId={`searchProd_${index}`} {...props} />
                    </>
                ))}
            </Slider>
        </div>
    )
}
export default ProductsSlider
